module.exports = __webpack_public_path__ + "static/a-xx-034-art-9dabaef231d1589badd8be0cd395ecf7.jpg";